interface OnboardingStepDto {
  id: string;
  title: string;
  description?: string;
}

export interface OnboardingInitResponse {
  steps: OnboardingStepDto[];
}

export interface OnboardingFinishRequest {
  completedStepIds: string[];
}

/** 设计文档：没有完成的用户进入 Onboarding */
export const ONBOARDING_STAGE_COMPLETED = "completed";

export interface OnboardingStatusResult {
  onboardingStage?: string;
  shouldEnter: boolean;
  /** API 客户端未就绪或请求失败时为 true；不应视为 onboarding 已完成 */
  unavailable?: boolean;
}

export interface OnboardingApi {
  getInitialState: () => Promise<OnboardingInitResponse>;
  finishOnboarding: (payload: OnboardingFinishRequest) => Promise<void>;
  /** GET /user/onboarding-status — useOnboardingEntryGate 冷启动/登录后判断是否应进入 /onboarding */
  getOnboardingStatus: () => Promise<OnboardingStatusResult>;
}
